<template>
  <NuxtLink
    class="tag"
    :class="{ 'is-active': currentQueryValue === queryValue }"
    :to="to"
  >
    {{ label }}
  </NuxtLink>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    label: string
    queryKey: string
    queryValue?: string
  }>(),
  {
    queryValue: '',
  },
)

const currentQueryValue = useQueryString(props.queryKey)

const isActive = computed(() => currentQueryValue.value === props.queryValue)

const to = computed(() => {
  if (!props.queryValue) {
    return {
      query: {},
    }
  }

  return {
    query: {
      [props.queryKey]: isActive.value ? undefined : props.queryValue,
    },
  }
})
</script>

<style lang="postcss" scoped>
.tag {
  @apply mr-10 mb-10 rounded-full border border-black items-center text-xs uppercase font-bold leading-none py-10 px-12.5 bg-black text-white select-none;
  @apply hover:bg-gray-dark hover:border-gray-dark;
  &.is-active {
    @apply bg-white text-black border-black;
  }
}
</style>
